import React, { useState, useEffect } from 'react';
import { InstagramEmbed, YouTubeEmbed} from 'react-social-media-embed';
import '../style/base.css';
import '../style/navbar.css';
import '../style/pages.css';
import '../style/responsive.css';
import '../style/sidebar.css';

const Portfolio = () => {
  const [portfolioData, setPortfolioData] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState('All');
  const [visibleProjects, setVisibleProjects] = useState(9);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPortfolioData();
  }, []);

  const loadPortfolioData = async () => {
    try {
      const response = await fetch('/content.json');
      const data = await response.json();
      setPortfolioData(data.portfolio);
      setLoading(false);
    } catch (error) {
      console.error('Error loading portfolio data:', error);
      setLoading(false);
    }
  };

  const loadMore = () => {
    setVisibleProjects(prev => prev + 9);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100) {
        loadMore();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleProjectClick = (e, project) => {
    e.preventDefault();
    setSelectedProject(project);
    setIsPopupOpen(true);
  };

  const handleFilterClick = (category) => {
    setActiveFilter(category);
  };

  if (loading || !portfolioData) {
    return (
      <article className="portfolio active" data-page="portfolio">
        <header>
          <h2 className="h2 article-title">Portfolio</h2>
        </header>
        <p>Loading content...</p>
      </article>
    );
  }

  const categories = [...new Set(portfolioData.projects.map(project => project.category))];
  
  const filteredProjects = activeFilter === 'All' 
    ? portfolioData.projects 
    : portfolioData.projects.filter(project => project.category === activeFilter);

  const displayedProjects = filteredProjects.slice(0, visibleProjects);

  return (
    <article className="portfolio active" data-page="portfolio">
      <header>
        <h2 className="h2 article-title">{portfolioData.title}</h2>
      </header>

      <section className="projects">
        <ul className="filter-list">
          <li className="filter-item">
            <button 
              className={activeFilter === 'All' ? 'active' : ''} 
              onClick={() => handleFilterClick('All')}
            >
              All
            </button>
          </li>
          {categories.map((category, index) => (
            <li key={index} className="filter-item">
              <button 
                className={activeFilter === category ? 'active' : ''} 
                onClick={() => handleFilterClick(category)}
              >
                {category}
              </button>
            </li>
          ))}
        </ul>

        <ul className="project-list">
          {displayedProjects.map((project, index) => (
            <li 
              key={index} 
              className="project-item active" 
              data-filter-item 
              data-category={project.category}
              onClick={(e) => handleProjectClick(e, project)}
            >
              <a href="#" onClick={(e) => handleProjectClick(e, project)}>
                <figure className="project-img spacing-10">
                  <div className="project-item-icon-box">
                    <ion-icon name="eye-outline"></ion-icon>
                  </div>
                  <img 
                    src={project.image} 
                    alt={project.title} 
                    loading="lazy"
                    style={{ width: '100%', height: 'auto', minHeight: '250px', objectFit: 'cover' }}
                  />
                </figure>
                <h3 className="project-title spacing-10">{project.title}</h3>
                <p className="project-category spacing-10">{project.category}</p>
              </a>
            </li>
          ))}
        </ul>
      </section>

      {isPopupOpen && selectedProject && (
        <div className="modal-container active" data-modal-container>
          <div className="overlay" data-overlay onClick={() => setIsPopupOpen(false)}></div>
          <section className="testimonials-modal">
            <button 
              className="modal-close-btn" 
              data-modal-close-btn 
              onClick={() => setIsPopupOpen(false)}
            >
              <ion-icon name="close-outline"></ion-icon>
            </button>

            <div className="modal-content">
              <h4 className="h3 modal-title" data-modal-title>{selectedProject.title}</h4>
              <time datetime={selectedProject.date}>{selectedProject.category}</time>
              <div data-modal-text>
                <p>{selectedProject.description}</p>
              </div>
              <div className="modal-img-wrapper">
                {selectedProject.Gridimages && selectedProject.Gridimages.split(',').map((imageUrl, index) => (
                  <img 
                    key={index}
                    src={imageUrl.trim()} 
                    alt={`Grid image ${index + 1}`}
                    className="grid-image"
                    style={{ display: 'block', width: '100%', height: 'auto' }}
                    loading="lazy"
                  />
                ))}
                {selectedProject.videoUrl && (
                  selectedProject.videoUrl.split(',').map((url, index) => (
                    <div key={index} style={{ display: 'flex', justifyContent: 'center' }}>
                      <YouTubeEmbed url={url.trim()} width={325} height={220} />
                    </div>
                  ))
                )}
                {selectedProject.driveUrl && (
                  selectedProject.driveUrl.split(',').map((url, index) => (
                    <figure key={index} className="modal-avatar-box">
                      <iframe 
                        src={url.trim()} 
                        allow="autoplay"
                        style={{ width: '100%', height: 'auto'}}
                        title={`Drive preview ${index + 1}`}
                      ></iframe>
                    </figure>
                  ))
                )}
                {selectedProject.instagramUrl && (
                  selectedProject.instagramUrl.split(',').map((url, index) => (
                    <div key={index} style={{ display: 'flex', justifyContent: 'center' }}>
                      <InstagramEmbed url={url.trim()} width={328} />
                    </div>
                  ))
                )}
              </div>
              <a 
                href={selectedProject.url} 
                target="_blank"
                rel="noopener noreferrer" 
                className="form-btn"
              >
                View All Project
              </a>
            </div>
          </section>
        </div>
      )}
    </article>
  );
};

export default Portfolio;
